<template lang="pug">
	.v-page-section-projects.page-section-projects(v-if="section" )
		v-section-slider(:data-source="section" template="projects" :options="options")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import breakpoints from "scripts/breakpoints.js";

export default {
	mixins: [sourceMixin],

	data() {
		return {
			section: null,
			options: {
				slidesPerView: 4,
				spaceBetween: 20,
				breakpoints: {
					[breakpoints['md-min']]: {
						slidesPerView: 4
					},
					[breakpoints['xs-min']]: {
						slidesPerView: 2
					},
					[breakpoints['4xs-min']]: {
						slidesPerView: 1
					}
				}
			}
		};
	},

	methods: {
		dataSet(data) {
			this.section = data;
		}
	}
};
</script>